import { workloadStatusesEnum } from "helpers/enums";
import React, { useEffect } from "react";
import { alert } from "services/alert";
import { downloadGeneratedReport } from "sources/books/reports";

const DownloadGeneratedReportTask = ({ status, taskKey, fileName, removeItem }) => {
    const download = () => {
        removeItem({ key: taskKey });
        downloadGeneratedReport(taskKey, fileName);
    };
    useEffect(() => {
        if (status === workloadStatusesEnum.Faulted) {
            alert({
                type: "error",
                title: "Ошибка",
                message: <small>При формировании отчета произошла ошибка</small>,
            });
        } else {
            alert({
                type: "success",
                title: "Отчет сформирован",
                timeOut: 0,
                message: <small>Нажмите, чтобы скачать его</small>,
                callback: download,
            });
        }
    }, []);
    if (status === workloadStatusesEnum.Faulted) {
        return <span className="text-danger">Ошибка</span>;
    } else {
        return (
            <span className="text-primary" onClick={download}>
                Скачать
            </span>
        );
    }
};

export default DownloadGeneratedReportTask;
